import { ModelHelper } from '../classes/model-helper';

export class Country {
	code: string;
	name: string;
	endOfRegistration: Date;
	shutdownDatePurchaser: Date;
	shutdownDateContractor: Date;
	shutdownPhase: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Country
	 */
	static map(data: any, item: Country = new Country()): Country {
		return item.map(data);
	}

	/**
	 * Maps the given item as a new date.
	 *
	 * @param the item to map
	 * @returns the item as a date object
	 */
	mapDate(item) {
		return new Date(item);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Country
	 */
	public map(data: any): Country {
		ModelHelper.map(data, this, 'code');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'endOfRegistration');
		ModelHelper.map(data, this, 'shutdownDatePurchaser', { map: this.mapDate });
		ModelHelper.map(data, this, 'shutdownDateContractor', { map: this.mapDate });
		ModelHelper.map(data, this, 'shutdownPhase');

		return this;
	}

	/**
	 * Prepare data for API
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		return data && data.code ? { code: data.code } : null;
	}
}
